import { settings } from '../settings';
import Fetch from '../utils/fetch';
import { ReqEnum } from '../const/requestStatus';
import {
  ParcelWithLocation,
  WarehouseOrder,
} from '../pages/WarehouseSystem/WarehouseSystem';

export async function registerOrderParcelInWarehouse(
  orderId: string,
  parcelIds: ParcelWithLocation[]
): Promise<Response> {
  const response: Response = await Fetch.post({
    url: `${settings.newApiUrl}/warehouse/${orderId}`,

    body: {
      parcelIds,
    },
  });
  return response;
}

export async function registerOrderParcelInWarehouseByParcelId(
  orderId: string,
  parcelId: string,
  warehouseLocation: string
): Promise<Response> {
  const response: Response = await Fetch.post({
    url: `${settings.newApiUrl}/warehouse/${orderId}/${parcelId}/${warehouseLocation}`,
  });
  return response;
}

export async function getOrdersInWarehouse(): Promise<{
  orders: WarehouseOrder[];
  status: string;
}> {
  const response: Response = await Fetch.get({
    url: `${settings.newApiUrl}/warehouse`,
  });

  if (response.ok) {
    return { orders: await response.json(), status: ReqEnum.SUCCESS };
  } else {
    return { orders: [], status: ReqEnum.ERROR };
  }
}
